
import { Box, Menu, styled, type SxProps } from '@mui/material'
import { ActionButton } from 'Components/Menu/ActionButton'
import { useRef } from 'react'
const StyledMenu = styled(Menu)`
.MuiPaper-root{
    border: 1px solid black;
  border-radius:16px;
}
`

export interface ActionButtonProps {
  open: boolean
  testId?: string
  onClose: () => void
  onShow: () => void
  children: JSX.Element
  menuProps?: SxProps
}

export function ActionMenu (props: ActionButtonProps): JSX.Element {
  const ref = useRef()
  return <>
    <Box ref={ref}>
      <ActionButton onClick={props.onShow} testId={`${props.testId ?? 'menu'}-button`} buttonSx={props.menuProps}/>
    </Box>

    <StyledMenu open={props.open} data-testid={props.testId} anchorEl={ref.current} onClose={props.onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
    >
      {props.children}
    </StyledMenu>
  </>
}
